/**
 * @copyright 2026 @ DigiNet
 * @author YENNHI
 * @create 05/08/2026
 * @update 05/08/2026
 */

import { Column, Summary, TotalItem } from "devextreme-react/data-grid";
import { Col, Modal, ModalBody, ModalHeader, Row, NumberInput } from 'diginet-core-ui/components';
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as W17F20404Actions from "../../actions/w17/w17F2040/w17f2040-actions";
import Config from "../../config";
import GridContainer from "../common/grid-container/grid-container";
import { Loading } from "../common/loading/loadingCore";
import { makeStyles } from "diginet-core-ui/theme";

const useStyles = makeStyles(({ spacing, colors }) => {
    return {
        moneyInputColumn: {
            width: '100%',
            '& input': {
                textAlign: 'right'
            }
        },
    }
});

const W17f2040PopUpPercentDiscount = (props) => {
    const { openModal, onClose, quotationID, formID } = props;
    const classes = useStyles();
    const [formLoading, setFormLoading] = useState(false);

    const [dataGrid, setDataGrid] = useState([]);
    useEffect(() => {
        loadPoHH();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    
    const loadPoHH = () => {
        const params = {
            FormID: formID,
            DataType: "LoadPovHH",
            QuotationID: quotationID || "",
            Mode: 0,
        }
        setFormLoading(true);
        props.W17F20404Actions.loadPoHH(params, (err, data) => {
            setFormLoading(false);
            if (err) {
                Config.popupCore.show('ERROR', err);
                return false;
            } else if (data) {
                setDataGrid(data);
            }
        });
    };

    const renderNumberFormat = (e) => {
        if (!e) return false;
        const value = e?.value ?? null;
        return <NumberInput
            nonStyle
            readOnly
            decimalDigit={8}
            maxDigit={28}
            thousandSeparator={','}
            value={value}
            className={classes.moneyInputColumn}
        />
    };

    return (
        <>
            <Modal open={openModal} size={'xl'} onClose={() => onClose && onClose(false)}>
                <ModalHeader title={Config.lang('Chi_tiet_hoa_hong')} />
                <ModalBody style={{ minHeight: 500 }}>
                    <Loading visible={formLoading} />
                    <Row>
                        <Col xs={12}>
                            <GridContainer
                                totalItems={dataGrid.length}
                                dataSource={dataGrid}
                                hoverStateEnabled={true}
                                keyExpr={'InventoryID'}
                                typePaging={'normal'}
                                itemPerPage={50}
                                listPerPage={[50, 100, 150, 200]}
                                elementAttr={{ style: 'min-height: 420px' }}
                            >
                                <Column
                                    width={250}
                                    dataField={"InventoryID"}
                                    caption={Config.lang("Ma_hang")}
                                />
                                <Column
                                    minWidth={250}
                                    dataField={"InventoryName"}
                                    caption={Config.lang("Ten_hang")}
                                />
                                <Column
                                    width={200}
                                    dataField={"GroupInv"}
                                    caption={Config.lang("Nhom_hang")}
                                />
                                <Column
                                    width={160}
                                    dataType={"number"}
                                    dataField={"QtyInv"}
                                    caption={Config.lang("So_luong")}
                                    cellRender={renderNumberFormat}
                                />
                                <Column
                                    width={200}
                                    dataField={"CommissionDiscountID"}
                                    caption={Config.lang("Chinh_sach")}
                                />
                                <Column
                                    width={180}
                                    dataType={"number"}
                                    dataField={"CommissionDiscountAmount"}
                                    caption={Config.lang("Hoa_hong")}
                                    cellRender={renderNumberFormat}
                                />
                                <Summary>
                                    <TotalItem
                                        displayFormat={"{0}"}
                                        column={'QtyInv'}
                                        valueFormat={(e) => Config.numberFormat(e, 8)}
                                        summaryType={"sum"}
                                    />
                                    <TotalItem
                                        displayFormat={"{0}"}
                                        column={'CommissionDiscountAmount'}
                                        valueFormat={(e) => Config.numberFormat(e, 8)}
                                        summaryType={"sum"}
                                    />
                                </Summary>
                            </GridContainer>
                        </Col>
                    </Row>
                </ModalBody>
            </Modal>
        </>
    )
};

export default connect(null,
    (dispatch) => ({
        W17F20404Actions: bindActionCreators(W17F20404Actions, dispatch),
    }))(W17f2040PopUpPercentDiscount);